import _extends from "@babel/runtime/helpers/esm/extends";
import React, { useState } from "react";
import { Button as BootstrapButton } from "react-bootstrap";
import { SitecoreLink } from '../../link/Link';
export var Button = function Button(props) {
  var disabled = props.disabled,
      loading = props.loading,
      children = props.children,
      className = props.className;
  var disabledState = disabled || loading;
  var classState = "".concat(className, " ").concat(loading ? " is-fetching" : "");
  return /*#__PURE__*/React.createElement("button", _extends({}, props, {
    disabled: disabledState,
    className: classState
  }), children);
};
export var StateBootstrapButton = function StateBootstrapButton(props) {
  var disabled = props.disabled,
      loading = props.loading,
      children = props.children,
      className = props.className;
  var disabledState = disabled || loading;
  var classState = "".concat(className, " ").concat(loading ? " is-fetching" : "");
  return /*#__PURE__*/React.createElement(BootstrapButton, _extends({}, props, {
    disabled: disabledState,
    className: classState
  }), children);
};
export var RouterStateButton = function RouterStateButton(props) {
  var disabled = props.disabled,
      loading = props.loading,
      children = props.children,
      className = props.className;
  var disabledState = disabled || loading;
  var classState = "".concat(className, " ").concat(loading ? " is-fetching" : "");
  return /*#__PURE__*/React.createElement(SitecoreLink, {
    disabled: disabledState,
    onClick: props.onClick,
    field: {
      value: {
        href: props.href
      }
    }
  }, /*#__PURE__*/React.createElement(BootstrapButton, {
    as: "span" // {...props}
    // disabled={disabledState}
    ,
    className: classState
  }, children));
};